import HTTP from '.';
import AttachedFileServiceMock from './mocks/AttachedFileService.mock';
import config from '@/config';

export default class AttachedFileService {
  static addAttachedFile(data) {
    if (config.ENV.MOCK === true) {
      return AttachedFileServiceMock.getActivtyAreas();
    }

    const formData = new FormData();
    formData.append('file', data.photo);
    formData.append('description', data.description ? data.description : '');

    return HTTP.post('/api/currentmember/attachedfiles/upload', formData);
  }

  static getAttachedFile(id) {
    if (config.ENV.MOCK === true) {
      return AttachedFileServiceMock.getAttachedFile();
    }

    return HTTP.get(`/api/currentmember/attachedfiles/${id}`);
  }

  static getAttachedFiles(ids) {
    if (config.ENV.MOCK === true) {
      return AttachedFileServiceMock.getAttachedFiles();
    }

    let idsString = '?';
    for (let i = 0; i < ids.length; i += 1) {
      idsString += `ids=${ids[i]}&`;
    }
    idsString = idsString.slice(0, -1);

    return HTTP.get(`/api/currentmember/attachedfiles/getByIds/${idsString}`);
  }

  static getFile(id) {
    if (config.ENV.MOCK === true) {
      return AttachedFileServiceMock.getFile();
    }

    return HTTP.get(`/api/currentmember/attachedfiles/${id}/file`);
  }

  static deleteFileById(id) {
    if (config.ENV.MOCK === true) {
      return AttachedFileServiceMock.deleteFileById();
    }

    return HTTP.delete(`/api/currentmember/attachedfiles/${id}`);
  }
}
